import React, { useState, useEffect } from "react";

const API_URL = "https://comoticket-production.up.railway.app/api";
const EUR_TO_KMF = 491.96;
const toKMF = (eur) => Math.round(parseFloat(eur) * EUR_TO_KMF).toLocaleString("fr-FR");

export default function PublicPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(API_URL + "/public/events")
      .then(r => r.json())
      .then(data => { setEvents(data.filter(e => new Date(e.date) >= new Date() || e.available_tickets > 0)); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .event-card:hover { transform: translateY(-6px); }
        .event-card { transition: transform 0.25s ease; cursor: pointer; }
        .tag { display: inline-block; background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.7); padding: 4px 12px; border-radius: 100px; font-size: 11px; font-weight: 600; margin-right: 6px; }
      `}</style>

      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800}}>C</div>
          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px"}}>ComoTicket</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <a href="/compte/connexion" style={{color:"rgba(255,255,255,0.7)",fontSize:13,textDecoration:"none",fontWeight:600}}>Mon espace</a><a href="/revendeurs" style={{background:"rgba(255,255,255,0.08)",border:"1.5px solid rgba(255,255,255,0.2)",color:"white",padding:"9px 18px",borderRadius:100,fontWeight:700,fontSize:13,textDecoration:"none"}}>O&ugrave; acheter mon billet</a>
          <a href="/verifier" style={{color:"rgba(255,255,255,0.7)",fontSize:13,textDecoration:"none",fontWeight:600}}>V&eacute;rifier mon billet</a><a href="/organisateur" style={{background:"#2563eb",color:"white",padding:"9px 20px",borderRadius:100,fontWeight:700,fontSize:13,textDecoration:"none"}}>Je suis organisateur</a>
        </div>
      </nav>

      <div style={{padding:"60px 40px 20px",maxWidth:1200,margin:"0 auto"}}>
        <div style={{marginBottom:48}}>
          <h1 style={{fontSize:52,fontWeight:900,letterSpacing:"-2px",lineHeight:1.1,marginBottom:16}}>
            Les meilleurs<br /><span style={{color:"#2563eb"}}>&eacute;v&eacute;nements</span> aux Comores
          </h1>
          <p style={{fontSize:17,color:"rgba(255,255,255,0.5)",maxWidth:500}}>
            D&eacute;couvrez les &eacute;v&eacute;nements &agrave; venir et achetez vos billets en cash auprès de nos commer&ccedil;ants agr&eacute;&eacute;s.
          </p>
        </div>

        {loading ? (
          <div style={{textAlign:"center",padding:80,color:"rgba(255,255,255,0.3)"}}>
            <div style={{fontSize:14,letterSpacing:"0.1em",textTransform:"uppercase"}}>Chargement...</div>
          </div>
        ) : events.length === 0 ? (
          <div style={{textAlign:"center",padding:80,color:"rgba(255,255,255,0.3)"}}>
            <div style={{fontSize:48,marginBottom:16}}>&#127917;</div>
            <div style={{fontSize:16}}>Aucun &eacute;v&eacute;nement disponible pour le moment</div>
          </div>
        ) : (
          <>
            {events[0] && (
              <div className="event-card" style={{background:"#111",borderRadius:20,overflow:"hidden",marginBottom:32,display:"grid",gridTemplateColumns:"1fr 1fr",minHeight:380}}>
                <div style={{position:"relative",overflow:"hidden"}}>
                  {events[0].image_url ? (
                    <img src={events[0].image_url} alt={events[0].name} style={{width:"100%",height:"100%",objectFit:"cover"}} />
                  ) : (
                    <div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#1a1a2e,#16213e,#0f3460)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:80}}>&#127925;</div>
                  )}
                  <div style={{position:"absolute",inset:0,background:"linear-gradient(to right,transparent,#111)"}} />
                </div>
                <div style={{padding:40,display:"flex",flexDirection:"column",justifyContent:"center"}}>
                  <div style={{marginBottom:12}}>
                    <span className="tag">&Agrave; venir</span>
                    <span className="tag">Vedette</span>
                  </div>
                  <h2 style={{fontSize:32,fontWeight:900,letterSpacing:"-1px",marginBottom:12,lineHeight:1.2}}>{events[0].name}</h2>
                  <div style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:8}}>
                    &#128197; {new Date(events[0].date).toLocaleDateString("fr-FR",{weekday:"long",year:"numeric",month:"long",day:"numeric",hour:"2-digit",minute:"2-digit",timeZone:"UTC"})}{events[0].end_date ? " → " + new Date(events[0].end_date).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit",timeZone:"UTC"}) : ""}
                  </div>
                  <div style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:24}}>
                    &#128205; {events[0].location}
                  </div>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div>
                      <div style={{fontSize:28,fontWeight:900,color:"#2563eb"}}>{toKMF(events[0].ticket_price)} KMF</div>
                      <div style={{fontSize:12,color:"rgba(255,255,255,0.3)"}}>{parseFloat(events[0].ticket_price).toFixed(2)} EUR</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontSize:13,color:parseInt(events[0].available_tickets)>0?"#10b981":"#ef4444",fontWeight:600}}>
                        {parseInt(events[0].available_tickets)>0 ? parseInt(events[0].available_tickets)+" places dispo" : "Complet"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <h2 style={{fontSize:22,fontWeight:800,marginBottom:24,letterSpacing:"-0.5px"}}>Tous les &eacute;v&eacute;nements</h2>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:20,marginBottom:60}}>
              {events.map((evt) => {
                const available = parseInt(evt.available_tickets) || 0;
                const total = parseInt(evt.total_tickets) || 1;
                const pct = Math.round(((total-available)/total)*100);
                return (
                  <div key={evt.id} className="event-card" style={{background:"#111",borderRadius:16,overflow:"hidden",border:"1px solid rgba(255,255,255,0.06)"}}>
                    <div style={{position:"relative",height:180,overflow:"hidden"}}>
                      {evt.image_url ? (
                        <img src={evt.image_url} alt={evt.name} style={{width:"100%",height:"100%",objectFit:"cover"}} />
                      ) : (
                        <div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#1a1a2e,#0f3460)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:50}}>&#127917;</div>
                      )}
                      <div style={{position:"absolute",top:12,right:12}}>
                        <span style={{background:available>0?"#10b981":"#ef4444",color:"white",padding:"4px 10px",borderRadius:100,fontSize:11,fontWeight:700}}>
                          {available>0 ? available+" places" : "Complet"}
                        </span>
                      </div>
                    </div>
                    <div style={{padding:18}}>
                      <h3 style={{fontSize:16,fontWeight:800,marginBottom:8,letterSpacing:"-0.3px",lineHeight:1.3}}>{evt.name}</h3>
                      <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginBottom:4}}>
                        &#128197; {new Date(evt.date).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric",hour:"2-digit",minute:"2-digit",timeZone:"UTC"})}{evt.end_date ? " → " + new Date(evt.end_date).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit",timeZone:"UTC"}) : ""}
                      </div>
                      <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginBottom:14}}>
                        &#128205; {evt.location}
                      </div>
                      <div style={{height:3,background:"rgba(255,255,255,0.08)",borderRadius:100,marginBottom:14,overflow:"hidden"}}>
                        <div style={{height:"100%",background:pct>80?"#ef4444":pct>50?"#f59e0b":"#10b981",borderRadius:100,width:pct+"%"}} />
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <div>
                          <div style={{fontSize:20,fontWeight:900,color:"#2563eb"}}>{toKMF(evt.ticket_price)} KMF</div>
                          <div style={{fontSize:11,color:"rgba(255,255,255,0.3)"}}>{parseFloat(evt.ticket_price).toFixed(2)} EUR</div>
                        </div>
                        <a href="/revendeurs" style={{fontSize:11,color:"#60a5fa",textAlign:"right",textDecoration:"none",fontWeight:700,border:"1px solid rgba(37,99,235,0.3)",padding:"6px 10px",borderRadius:8,background:"rgba(37,99,235,0.08)"}}>
                          O&ugrave; acheter mon billet &rarr;
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        <div style={{background:"#111",borderRadius:20,padding:48,border:"1px solid rgba(255,255,255,0.06)",marginBottom:40}}>
          <h2 style={{fontSize:28,fontWeight:900,letterSpacing:"-1px",marginBottom:8,textAlign:"center"}}>Comment acheter un billet ?</h2>
          <p style={{color:"rgba(255,255,255,0.4)",textAlign:"center",marginBottom:40,fontSize:14}}>Simple, rapide et en cash</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:32}}>
            {[
              {emoji:"&#127978;",title:"1. Trouvez un commer&ccedil;ant",desc:"Rendez-vous chez l'un de nos commer&ccedil;ants agr&eacute;&eacute;s pr&egrave;s de chez vous"},
              {emoji:"&#128176;",title:"2. Payez en cash",desc:"Payez le montant du billet en esp&egrave;ces directement au commer&ccedil;ant"},
              {emoji:"&#127918;",title:"3. Recevez votre billet",desc:"Recevez votre billet &eacute;lectronique avec QR code par email ou WhatsApp"},
            ].map((step,i) => (
              <div key={i} style={{textAlign:"center",padding:"24px 16px",background:"rgba(255,255,255,0.03)",borderRadius:16,border:"1px solid rgba(255,255,255,0.06)"}}>
                <div style={{fontSize:40,marginBottom:16}} dangerouslySetInnerHTML={{__html: step.emoji}} />
                <div style={{fontSize:15,fontWeight:700,marginBottom:8}} dangerouslySetInnerHTML={{__html: step.title}} />
                <div style={{fontSize:13,color:"rgba(255,255,255,0.4)",lineHeight:1.6}} dangerouslySetInnerHTML={{__html: step.desc}} />
              </div>
            ))}
          </div>
        </div>

        <div style={{textAlign:"center",padding:"24px 0",borderTop:"1px solid rgba(255,255,255,0.06)",fontSize:12,color:"rgba(255,255,255,0.2)"}}>
          ComoTicket &mdash; Billetterie simple pour tous &mdash; Les Comores
        </div>
      </div>
    </div>
  );
}